import React, { FunctionComponent } from "react";

import { bemClassNames } from "@multiweb/reactUtils";

export type FloatMenuPanelProps = {
    /** Příznak, zda je zakázáno překrývání okolního obsahu */
    disabled?: boolean;
};

const classNames = bemClassNames("float-menu-panel");

/** Plovoucí panel menu pro překrývání formulářové oblasti. */
export const FloatMenuPanel: FunctionComponent<FloatMenuPanelProps> = ({
    children,
    disabled = false,
}) => (
    <div className={classNames()}>
        <div className={classNames("content", { disabled })}>
            {children}
        </div>
    </div>
);
